<template>
  <el-dialog
    :title="$fanyi('选择优惠券或代金券')"
    :visible.sync="$parent.CouponsShow"
    width="520px"
  >
    <div class="Con" v-if="arrType.length != 0 || arrData.length != 0">
      <!-- 代金券 -->
      <div class="singleCoupon preferential">
        <!-- 如果没达到使用条件就让它点击 -->
        <div
          class="flex couponItem preferential"
          :class="{ active: active.arrType == index }"
          v-for="(item, index) in arrType"
          :key="index"
          v-show="
            $fun.ceil(
              $parent.orderPriceGroup.sum_price * $parent.datas.exchange_rate,
            ) > item.restrictions
          "
          @click="
            $fun.ceil(
              $parent.orderPriceGroup.sum_price * $parent.datas.exchange_rate,
            ) < item.restrictions
              ? $message.error($fanyi('未达到使用条件'))
              : active.arrType == index
              ? (active.arrType = -1)
              : (active.arrType = index)
          "
        >
          <div class="checkBox"></div>
          <div class="shadowBox">
            <div class="radial-gradient">
              <div
                class="optCon"
                v-bind:class="{
                  notUser:
                    $fun.ceil(
                      $parent.orderPriceGroup.sum_price *
                        $parent.datas.exchange_rate,
                    ) < item.restrictions,
                }"
              >
                <p class="title">
                  {{ $fanyi("编号") }}：{{ item.number }}
                  <span class="couponType"> {{ $fanyi("代金券") }}</span>
                </p>
                <p class="price">{{ item.free_kin }}{{ $fanyi("欧元") }}</p>
                <p class="condition">
                  {{ $fanyi("订单金额必须大于") }}
                  {{ item.restrictions }}
                </p>
                <p class="time">
                  {{ $fanyi("有效期") }}:
                  {{ item.free_datetime_start.substr(0, 10) }} /
                  {{ item.free_datetime_end.substr(0, 10) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 优惠券 -->
      <div class="singleCoupon kims">
        <div
          v-for="(item, index) in arrData"
          :key="index"
          class="flex couponItem kims"
          :class="{ active: active.arrData == index }"
          v-show="
            $fun.ceil(
              $parent.orderPriceGroup.sum_price * $parent.datas.exchange_rate,
            ) > item.restrictions
          "
          @click="
            $fun.ceil(
              $parent.orderPriceGroup.sum_price * $parent.datas.exchange_rate,
            ) < item.restrictions
              ? $message.error($fanyi('未达到使用条件'))
              : active.arrData == index
              ? (active.arrData = -1)
              : (active.arrData = index)
          "
        >
          <div class="checkBox"></div>
          <div class="shadowBox">
            <div class="radial-gradient">
              <div
                class="optCon"
                v-bind:class="{
                  notUser:
                    $fun.ceil(
                      $parent.orderPriceGroup.sum_price *
                        $parent.datas.exchange_rate,
                    ) < item.restrictions,
                }"
              >
                <p class="title">
                  {{ $fanyi("编号") }}：{{ item.number }}
                  <span class="couponType"> {{ $fanyi("券") }}</span>
                </p>
                <p class="price">{{ $fanyi("无佣金") }}</p>
                <p class="condition">
                  {{ $fanyi("订单金额必须大于") }}
                  {{ item.restrictions }}
                </p>
                <p class="time">
                  {{ $fanyi("有效期") }}:
                  {{ item.free_datetime_start.substr(0, 10) }} /
                  {{ item.free_datetime_end.substr(0, 10) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notHaveCoupons" v-else>{{ $fanyi("暂无优惠券") }}</div>
    <div class="footer">
      <div class="btnGroup">
        <button @click="setData()">{{ $fanyi("确认") }}</button>
        <button class="quXiao" @click="$parent.CouponsShow = false">
          {{ $fanyi("取消") }}
        </button>
      </div>
      <div class="prompt">
        {{ $fanyi("注意:同一订单只能使用同一类型的优惠券。") }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {
        page: 1,
        pageSize: 999,
      },
      active: {
        arrType: -1,
        arrData: -1,
      },
      datas: [],
      arrType: [],
      arrData: [],
    };
  },
  components: {},
  created() {
    this.getData();
  },
  methods: {
    // 取消使用优惠券
    cancelCoupons() {
      this.active.arrType = -1;
      this.active.arrData = -1;
      this.setData();
    },
    // 保存数据
    setData() {
      let ids = [];
      if (this.active.arrType != -1) {
        ids.push(this.arrType[this.active.arrType].id);
      }
      if (this.active.arrData != -1) {
        ids.push(this.arrData[this.active.arrData].id);
      }
      this.$parent.CouponsData.ids = ids.join(",");
      this.$parent.CouponsShow = false;
      this.$parent.youHuiQuanShiYong = true;
      // 如果两种优惠券都没有使用就取消多选框选中
      if (this.active.arrData == -1 && this.active.arrType == -1) {
        this.$parent.youHuiQuanShiYong = false;
      }
      if (this.active.arrData == -1) {
        this.$parent.daijinSmall = false;
      } else {
        this.$parent.daijinSmall = true;
      }
      if (this.active.arrType == -1) {
        this.$parent.youhuiSmall = false;
      } else {
        this.$parent.youhuiSmall = true;
      }
      this.$parent.calculateOrder();
    },
    // 获取数据
    getData() {
      this.$api
        .couponGet(this.form)
        .then((res) => {
          this.datas = res.data;
          this.lists = {};
          this.arrType = res.data.data.filter((item) => item.type == 30);
          this.arrData = res.data.data.filter((item) => item.type != 30);
          this.$forceUpdate();
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
/deep/.el-dialog {
  border-radius: 16px;
  height: 662px;
  .el-dialog__header {
    height: 94px;
    display: flex;
    align-items: center;
    font-size: 18px;
  }
  .el-dialog__body {
    padding: 0 40px 40px;
  }
  .Con {
    margin-bottom: 20px;
    width: 100%;
    height: 420px;
    overflow-y: auto;
    overflow-x: hidden;

    // 单张优惠券
    .singleCoupon {
      --active-color: #009246;
      display: flex;
      flex-direction: column;
      overflow: visible;
      padding: 0 10px 10px;
      gap: 30px;
      .couponItem {
        border: 2px solid transparent;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        padding: 30px;
        position: relative;
        .checkBox {
          position: absolute;
          right: 30px;
          bottom: 30px;
          width: 20px;
          flex: 0 0 20px;
          height: 20px;
          background: #fff;
          border: 1px solid #eaecf0;
          border-radius: 4px;
        }

        .shadowBox {
          width: 100%;
          .radial-gradient {
            width: 100%;
            cursor: pointer;
            margin-right: 0;
            position: relative;
            display: flex;
            align-items: center;

            .optCon {
              width: 100%;
              > .title {
                height: 20px;
                font-size: 12px;
                // color: #ffffff;
                line-height: 12px;
                margin-bottom: 13px;
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
              .couponType {
                @extend .dip;
                padding: 0 8px;
                height: 28px;
                background: #eaf8e8;
                font-size: 12px;
                border-radius: 6px;
                color: #009246;
                line-height: 16px;
              }
              .condition {
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 4px;
              }
              .price {
                font-size: 31.2px;
                font-weight: bold;
                line-height: 31.2px;
                color: #013b2d;
                margin-bottom: 20px;
              }
              .time {
                font-size: 12px;
                line-height: 16px;
              }
            }
          }
        }
      }

      .couponItem.preferential.active {
        --active-color: #009246;
      }
      .couponItem.kims.active {
        --active-color: #009246;
      }
      .couponItem.active {
        border: 2px solid #009246;
        .checkBox {
          background: var(--active-color);

          &::after {
            content: "";
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
            width: 20.72%;
            height: 50.23%;
            border-right: 2px solid #fff;
            border-bottom: 2px solid #fff;
          }
        }
      }
    }
  }
  .footer {
    .prompt {
      font-size: 12px;
      font-weight: 400;
      color: #858c98;
      line-height: 16px;
      text-align: center;
    }
    .btnGroup {
      margin-bottom: 20.7px;
      text-align: center;
      button {
        width: 120px;
        height: 46px;
        background: #009246;
        border-radius: 12px;
        color: #ffffff;
        font-size: 16px;
        font-weight: 600;
        &.quXiao {
          background-color: white;
          color: #009246;
          border: 1px solid #009246;
          margin-left: 20px;
        }
      }
    }
  }
  .notHaveCoupons {
    height: 300px;
    font-size: 25px;
    width: 100%;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.notUser {
  opacity: 0.3 !important;
}
</style>
